import { createSlice } from '@reduxjs/toolkit';
import { persistDarkMode } from '../../../helpers/darkMode';
export const initialState = {
    darkMode: false
};
const slice = createSlice({
    name: 'darkMode',
    initialState,
    reducers: {
        setDarkMode: (state, action) => {
            try {
                state.darkMode = action.payload;
                persistDarkMode(action.payload);
            }
            catch (_a) { }
        }
    }
});
export const { setDarkMode } = slice.actions;
export default slice.reducer;
